import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type { DeleteRecordingArgs, UpdateRecordingArgs } from "../types"

export const recordingMutators = {
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateRecordingArgs }) => {
			await tx.mutate.meetingRecordings.update(args)
		},
	),
	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: DeleteRecordingArgs }) => {
			// Soft delete by setting isDeleted: true
			await tx.mutate.meetingRecordings.update({
				id: args.id,
				isDeleted: true,
			})
		},
	),
}
